module.exports = __webpack_public_path__ + "static/img/home_tzjsmfw_scdy.b2c870b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home_tzjsmfw_scdy.png
// module id = W+Qq
// module chunks = 21